
import { Component, Vue } from 'vue-property-decorator';
import PrescriptionDialog from './prescription-dialog.vue';
import {
    GetPatientDetail, GetNewsTems, GetTemList, GetContentDetail,
    GetZhengzhuang, GetTuijianOptions, GetTuijianzhengxings,
    PostCepingContent, EditContent
} from '../../request';
import { getCurrentTime } from '../../common';
@Component({
    components: {
        PrescriptionDialog,
    },
})
export default class AiWen extends Vue {
    private showPrescriptionDialog: boolean = false;
    private data: any = {
        template: {},
        collect_time: '',
        data: [],
        report: {
            主诉: [],
            主症: [],
            舌面脉: {
                舌: null,
                面: null,
                舌下: null,
                脉: null,
            },
            综合: {
                刻下症: [],
                中医疾病: [],
                中医证型: [],
                中药方剂: [],
                中药组成: [],
                用法用量: '',

            },
            建议: {}
        },
    };
    private patient: any = {};
    private dataQuery: any = {
        name: "",
        template_id: "",
        patient_id: "",
    };
    private step: any = 1;
    private selectedIds: any = [];
    private zhengzhuangOpts: any = [];
    private zhusuOptions: any = [
        '目前主要是发烧、感冒、咳嗽',
        '有头痛、头晕；或失眠，心悸；或胸闷、心慌',
        '有肠胃病症；胃口不好；口苦口干；腹泻；大便不好',
        '有黄疸，肝病；腹胀以及其它肝胆脾疾病',
        '有小便不好；腰肋痛；尿频尿急，浑浊',
        '有口齿出血；咳血便血尿血；皮肤青紫斑',
        '有糖尿病；有高血压；三高等',
        '有皮肤问题，如湿疹、疮、痔等；皮肤有紫癜',
        '身体有疼痛；有麻木，间隙疼痛麻木等。丘、痘等',
        '有妇科疾病，月经、乳房等疾病',
        '不孕不育',
        '小儿肠道、消化不好。腹泻、积食等',
        '小儿呼吸系统疾病；发热、咳喘等',
        '小儿皮肤问题',
        '小儿高热不明原因'
    ]
    private zhuzhengOpts: any = [];
    // 推荐列表（只读，不添加手动输入的内容）
    private kexiazhengOpts: any = [];
    private zhongyijibingOpts: any = [];
    private fangjiOpts: any = [];
    private zhengxingOpts: any = [];

    // 下拉选项（包含推荐列表和手动输入的内容）
    private kexiazhengSelectOpts: any = [];
    private zhongyijibingSelectOpts: any = [];
    private fangjiSelectOpts: any = [];
    private zhengxingSelectOpts: any = [];

    private sizhenResult: any = null;

    private isSelected(arr: any, item: any) {
        return arr.findIndex((val: any) => val.name === item.name) !== -1;
    }
    private goReport(name: any) {
        this.$router.push({
            path: "/main/report/ceping-report",
            query: {
                ids: JSON.stringify([this.data.report['舌面脉'][name].content_id]),
                ifShowFengmian: "否",
            },
        });
    }
    private getChufangText() {
        if (!this.data.report['综合']['中药组成'] || this.data.report['综合']['中药组成'].length === 0) {
            return '';
        }

        // 过滤掉没有名称的药材
        const validIngredients = this.data.report['综合']['中药组成'].filter((item: any) => {
            // 适配新的数据格式：item.herb.name
            const name = item.herb && item.herb.name;
            return name && name.trim() !== '';
        });

        if (validIngredients.length === 0) {
            return '';
        }

        // 将药材格式化为 "名称 数量g" 的格式，如果没有数量则只显示名称
        const formattedIngredients = validIngredients.map((item: any) => {
            // 适配新的数据格式：item.herb.name
            const name = item.herb && item.herb.name;
            const quantity = item.quantity;

            if (quantity && String(quantity).trim() !== '') {
                return `${name} ${quantity}g`;
            } else {
                return name;
            }
        });

        return formattedIngredients.join('，');
    }
    /**
     * 上一步
     */
    private prev() {
        if (this.step == 1) {
            this.$router.back();
        } else {
            this.step -= 1;
            this.scrollToTop();
        }
    }
    /**
     * 下一步
     */
    private next() {
        if (this.step == 1) {
            if (this.data.report['主诉'].length == 0) {
                this.$message.error('请至少选择一个');
                return;
            }
            this.getZhengzhuang();
            this.step = 2;
            this.scrollToTop();
        } else if (this.step == 2) {
            if (this.data.report['主症'].length === 0) {
                this.$message.error('请至少选择一个症状');
                return;
            }
            this.step = 3;
            this.getTuijianOptions();
            this.getShemianmaiData();
            this.scrollToTop();
        }

    }

    // 滚动到顶部的方法
    scrollToTop() {
        this.$nextTick(() => {
            const contentElement = document.querySelector('#scroll-box') as HTMLElement;
            if (contentElement) {
                contentElement.scrollTop = 0;
            }
        });
    }
    private updateContent(e: any) {
        this.data = e;
        // 确保主症始终是数组格式
        if (this.data.report && this.data.report['主症']) {
            if (!Array.isArray(this.data.report['主症'])) {
                // 如果是字符串，转换为数组
                this.data.report['主症'] = this.data.report['主症'] ? [this.data.report['主症']] : [];
            }
        } else if (this.data.report) {
            this.data.report['主症'] = [];
        }
    }
    private async getZhengzhuang() {
        const params: any = {
            inquiry_questions: this.data.report['主诉'],
            disease__disease_diagnosises: this.data.report['主症'].join('|'),
        };
        const loading = this.$loading({
            lock: true,
            text: "加载中……",
            spinner: "el-icon-loading",
            customClass: "loadClass",
            background: "rgba(255, 255, 255, 0.7)",
        });
        const res = await GetZhengzhuang(this, params, loading);
        loading.close();
        this.zhengzhuangOpts = res.data;
        this.$forceUpdate();
    }
    private async getTuijianOptions() {
        // 刻下症推荐
        const res1 = await this.getKeXiaZhengOpts();
        // 中医疾病推荐
        const res2 = await this.getZhongYiJiBingOpts();

        // 处方推荐
        const res3 = await this.getFangjiOpts();
    }
    // 刻下症推荐
    private async getKeXiaZhengOpts() {
        const loading = this.$loading({
            lock: true,
            text: "加载中……",
            spinner: "el-icon-loading",
            customClass: "loadClass",
            background: "rgba(255, 255, 255, 0.7)",
        });
        const res = await GetTuijianOptions(this, {
            params: {
                only_key: '症状体征',
                disease__disease_diagnosises: this.data.report['主症'].join('|'),
            }
        }, loading);
        this.kexiazhengOpts = res.data;
        this.kexiazhengSelectOpts = [...res.data]; // 初始化下拉选项
        this.$forceUpdate();
    }
    // 中医疾病推荐
    private async getZhongYiJiBingOpts() {
        const loading = this.$loading({
            lock: true,
            text: "加载中……",
            spinner: "el-icon-loading",
            customClass: "loadClass",
            background: "rgba(255, 255, 255, 0.7)",
        });
        const res = await GetTuijianOptions(this, {
            params: {
                only_key: '中医疾病',
                disease__disease_diagnosises: this.data.report['主症'].join('|'),
            }
        }, loading);
        this.zhongyijibingOpts = res.data;
        // 更新选项
        const newOpts = [...this.data.report['综合']['中医疾病'], ...res.data];
        this.zhongyijibingSelectOpts = newOpts;
        loading.close();
        this.$forceUpdate();
    }
    // 处方推荐
    private async getFangjiOpts() {
        const loading = this.$loading({
            lock: true,
            text: "加载中……",
            spinner: "el-icon-loading",
            customClass: "loadClass",
            background: "rgba(255, 255, 255, 0.7)",
        });
        const params: any = {
            params: {
                only_key: '处方',
                disease__disease_diagnosises: this.data.report['主症'].join('|'),
            }
        }
        const syndrome = this.data.report['综合']['中医证型'].map((item: any) => item.name).join(',');
        if (syndrome) {
            params.params.syndromes = syndrome;
        }
        const res = await GetTuijianOptions(this, params, loading);
        this.fangjiOpts = res.data;
        // 更新选项
        const newOpts = [...this.data.report['综合']['中药方剂'], ...res.data];
        this.fangjiSelectOpts = newOpts;
        loading.close();
        this.$forceUpdate();
    }
    // 中医证型推荐
    private async getZhengxingOpts() {
        const loading = this.$loading({
            lock: true,
            text: "加载中……",
            spinner: "el-icon-loading",
            customClass: "loadClass",
            background: "rgba(255, 255, 255, 0.7)",
        });
        const params: any = {
            symptoms: this.data.report['综合']['刻下症'].map((item: any) => item.name),
            disease_diagnosises: this.data.report['主症'],
        }
        const diseases = this.data.report['综合']['中医疾病'].map((item: any) => item.name);
        if (diseases) {
            params.diseases = diseases;
        }
        const res = await GetTuijianzhengxings(this, params, loading);
        this.zhengxingOpts = res.data;
        // 更新选项
        const newOpts = [...this.data.report['综合']['中医证型'], ...res.data];
        this.zhengxingSelectOpts = newOpts;
        this.$forceUpdate();
        loading.close();
    }

    // 处理刻下症变化
    private handleKeXiaZhengChange() {
        if (this.data.report['综合']['刻下症']) {
            // 先处理所有字符串项，确保它们都被格式化为对象
            const processedItems = this.data.report['综合']['刻下症'].map((item: any) => {
                if (typeof item === 'string') {
                    const newItem = { name: item, id: item };
                    // 确保新选项被添加到下拉选项中
                    if (!this.kexiazhengSelectOpts.find((opt: any) => opt.name === item)) {
                        this.kexiazhengSelectOpts.push(newItem);
                    }
                    return newItem;
                }
                return item;
            });

            // 使用 $nextTick 确保选项已添加后再更新值
            this.$nextTick(() => {
                this.data.report['综合']['刻下症'] = processedItems;
                // 获取中医证型推荐
                this.getZhengxingOpts();
            });
        } else {
            // 获取中医证型推荐
            this.getZhengxingOpts();
        }
    }

    // 处理中医疾病变化
    private handleZhongYiJiBingChange() {
        if (this.data.report['综合']['中医疾病']) {
            // 先处理所有字符串项，确保它们都被格式化为对象
            const processedItems = this.data.report['综合']['中医疾病'].map((item: any) => {
                if (typeof item === 'string') {
                    const newItem = { name: item, id: item };
                    // 确保新选项被添加到下拉选项中
                    if (!this.zhongyijibingSelectOpts.find((opt: any) => opt.name === item)) {
                        this.zhongyijibingSelectOpts.push(newItem);
                    }
                    return newItem;
                }
                return item;
            });

            // 使用 $nextTick 确保选项已添加后再更新值
            this.$nextTick(() => {
                this.data.report['综合']['中医疾病'] = processedItems;
            });
        }
        this.getZhengxingOpts();
    }

    // 处理中医证型变化
    private handleZhongYiZhengXingChange() {
        if (this.data.report['综合']['中医证型']) {
            // 先处理所有字符串项，确保它们都被格式化为对象
            const processedItems = this.data.report['综合']['中医证型'].map((item: any) => {
                if (typeof item === 'string') {
                    const newItem = { name: item, id: item };
                    // 确保新选项被添加到下拉选项中
                    if (!this.zhengxingSelectOpts.find((opt: any) => opt.name === item)) {
                        this.zhengxingSelectOpts.push(newItem);
                    }
                    return newItem;
                }
                return item;
            });

            // 使用 $nextTick 确保选项已添加后再更新值
            this.$nextTick(() => {
                this.data.report['综合']['中医证型'] = processedItems;
            });
        }
        this.getFangjiOpts();
    }

    // 处理中药方剂变化
    private handleZhongYaoFangJiChange() {
        if (this.data.report['综合']['中药方剂']) {
            // 先处理所有字符串项，确保它们都被格式化为对象
            const processedItems = this.data.report['综合']['中药方剂'].map((item: any) => {
                if (typeof item === 'string') {
                    const newItem = { name: item, id: item };
                    // 确保新选项被添加到下拉选项中
                    if (!this.fangjiSelectOpts.find((opt: any) => opt.name === item)) {
                        this.fangjiSelectOpts.push(newItem);
                    }
                    return newItem;
                }
                return item;
            });

            // 使用 $nextTick 确保选项已添加后再更新值
            this.$nextTick(() => {
                this.data.report['综合']['中药方剂'] = processedItems;
            });
        }
    }

    private removeKeXiaZheng(index: any) {
        this.data.report['综合']['刻下症'].splice(index, 1);
        this.getZhengxingOpts();
    }
    private selectKeXiaZheng(item: any) {
        if (this.data.report['主症'].includes(item.name)) {
            return;
        }
        const index = this.data.report['综合']['刻下症'].findIndex((val: any) => val.name === item.name);
        if (index !== -1) {
            // 已存在，移除
            this.data.report['综合']['刻下症'].splice(index, 1);
        } else {
            // 不存在，添加
            this.data.report['综合']['刻下症'].push(item);
        }
        this.getZhengxingOpts();
    }
    private selectTuijian(item: any, key: any) {
        const index = this.data.report['综合'][key].findIndex((val: any) => val.name === item.name);
        if (index !== -1) {
            this.data.report['综合'][key].splice(index, 1);
        } else {
            this.data.report['综合'][key].push(item);

            // 确保选项在下拉选项中也存在
            let selectOptsKey = '';
            if (key === '中医疾病') {
                selectOptsKey = 'zhongyijibingSelectOpts';
            } else if (key === '中医证型') {
                selectOptsKey = 'zhengxingSelectOpts';
            } else if (key === '中药方剂') {
                selectOptsKey = 'fangjiSelectOpts';
            }

            if (selectOptsKey && (this as any)[selectOptsKey]) {
                // 检查是否已在下拉选项中
                const existingIndex = (this as any)[selectOptsKey].findIndex((opt: any) => opt.name === item.name);
                if (existingIndex === -1) {
                    // 如果不存在，添加到下拉选项中
                    (this as any)[selectOptsKey].push(item);
                }
            }

            // 如果是中药方剂被添加，需要将herbs添加到中药组成中
            if (key === '中药方剂' && item.herbs) {
                this.addHerbsToComposition(item.herbs);
            }
        }
        if (key === '中医疾病') {
            this.getZhengxingOpts();
            // 推荐证型
        } else if (key === '中医证型') {
            // 推荐处方
            this.getFangjiOpts();
        }
    }

    // 添加药材到中药组成中，避免重复
    private addHerbsToComposition(herbs: any[]) {
        if (!herbs || !Array.isArray(herbs)) return;

        herbs.forEach((herbItem: any) => {
            if (herbItem.herb && herbItem.herb.name) {
                // 检查是否已存在同名药材
                const existingIndex = this.data.report['综合']['中药组成'].findIndex(
                    (item: any) => (item.herb && item.herb.name) === herbItem.herb.name || item.name === herbItem.herb.name
                );

                if (existingIndex === -1) {
                    // 不存在同名药材，添加新药材
                    this.data.report['综合']['中药组成'].push({
                        herb: {
                            id: herbItem.herb.id,
                            name: herbItem.herb.name
                        },
                        quantity: herbItem.quantity || '',
                        unit: herbItem.unit || 'g'
                    });
                }
            }
        });
    }
    private selectZhuSu(item: any) {
        if (this.data.report && this.data.report['主诉'] && this.data.report['主诉'].includes(item)) {
            // 移除项目
            const newArray = this.data.report['主诉'].filter((val: any) => val !== item);
            this.$set(this.data.report, '主诉', newArray);
        } else {
            // 添加项目
            if (this.data.report && this.data.report['主诉'] && this.data.report['主诉'].length < 2) {
                const newArray = [...this.data.report['主诉'], item];
                this.$set(this.data.report, '主诉', newArray);
            } else {
                this.$message.error('最多选择2个');
            }
        }
    }
    private selectZhuZheng(item: any) {
        const index = this.data.report['主症'].indexOf(item);
        if (index !== -1) {
            // 已存在，移除
            this.data.report['主症'].splice(index, 1);
        } else {
            // 不存在，添加（最多选择3个）
            this.data.report['主症'] = [item]
            // if (this.data.report['主症'].length < 3) {
            //   this.data.report['主症'].push(item);
            // } else {
            //   this.$message.error('最多选择3个症状');
            // }
        }
    }

    private openPrescriptionDialog() {
        this.showPrescriptionDialog = true;
    }

    private handlePrescriptionConfirm(ingredients: any[]) {
        this.data.report['综合']['中药组成'] = ingredients;
        this.showPrescriptionDialog = false;
    }

    /**
     * 获取患者数据
     */
    private getPatientData() {
        if (!this.dataQuery.patient_id) {
            return;
        }
        GetPatientDetail(this, this.dataQuery.patient_id).then((res: any) => {
            this.patient = res.data;
            this.$store.commit("updatePatient", this.patient);
        });
    }
    /**
     * 获取舌面脉数据
     */
    private async getShemianmaiData() {
        if (this.sizhenResult) {
            this.data.report['舌面脉'] = this.sizhenResult;
            this.$forceUpdate();
            return;
        }
        // 需要调取接口拿数据 
        const loading = this.$loading({
            lock: true,
            text: "加载中……",
            spinner: "el-icon-loading",
            customClass: "loadClass",
            background: "rgba(255, 255, 255, 0.7)",
        });
        const params: any = {
            params: {
                patient_id: this.dataQuery.patient_id,
                related_type: "四诊客观化数据",
            },
        };
        const newstData = await GetNewsTems(this, params, loading);
        //从这里封装一个方法，根据name获取数据
        const sheData = await this.getCurrentData(newstData.data['四诊客观化数据'], '舌');
        const mianData = await this.getCurrentData(newstData.data['四诊客观化数据'], '面');
        const shexiaData = await this.getCurrentData(newstData.data['四诊客观化数据'], '舌下');
        const maiData = await this.getCurrentData(newstData.data['四诊客观化数据'], '脉');
        if (sheData) {
            this.selectedIds.push(sheData.content_id);
        }
        if (mianData) {
            this.selectedIds.push(mianData.content_id);
        }
        if (shexiaData) {
            this.selectedIds.push(shexiaData.content_id);
        }
        if (maiData) {
            this.selectedIds.push(maiData.content_id);
        }
        this.data.report['舌面脉']['舌'] = sheData;
        this.data.report['舌面脉']['面'] = mianData;
        this.data.report['舌面脉']['舌下'] = shexiaData;
        this.data.report['舌面脉']['脉'] = maiData;
        this.$forceUpdate();
    }
    /**
     * 提取最新舌面脉数据
     * @param arr 
     * @param name 
     */
    private async getCurrentData(arr: any, name: any) {
        let item;
        if (name === "舌") {
            item = arr.find((item: any) => item.name.includes("舌") && !item.name.includes("舌下"));
        } else if (name === "舌下") {
            item = arr.find((item: any) => item.name.includes("舌下"));
        } else {
            item = arr.find((item: any) => item.name.includes(name));
        }
        if (item && item.content_id && item.collect_time) {
            const today = getCurrentTime("yyyy-MM-dd");
            if (item.collect_time.includes(today)) {
                return item;
            }
        }
        return null;
    }
    /**
     * 获取数据
     */
    private getData() {
        this.data = {};
        // 特殊量表，正常是不会有content_id，因为只会是新增进入
        if (this.dataQuery.content_id) {
            this.getContent();
        } else {
            this.getTemplate();
        }
    }
    /**
     * 获取量表模版
     */
    private getTemplate() {
        const params: any = {
            params: {
                name: this.dataQuery.name,
                page: 1,
                ignore_permissions: "true",
            },
        };
        const loading = this.$loading({
            lock: true,
            text: "加载中……",
            spinner: "el-icon-loading",
            customClass: "loadClass",
            background: "rgba(255, 255, 255, 0.7)",
        });
        GetTemList(this, params, loading).then((res: any) => {
            this.data = {
                template: res.data[0],
                collect_time: getCurrentTime("yyyy-MM-dd HH:mm:ss"),
                data: res.data[0].fields,
                report: {
                    主诉: [],
                    主症: [],
                    舌面脉: {
                        舌: null,
                        面: null,
                        舌下: null,
                        脉: null,
                    },
                    综合: {
                        刻下症: [],
                        中医疾病: [],
                        中医证型: [],
                        中药方剂: [],
                        中药组成: [],
                        用法用量: '',

                    },
                    建议: {}
                },
            };
            this.$forceUpdate();
        });
    }
    /**
     * 获取量表数据
     */
    private getContent() {
        const loading = this.$loading({
            lock: true,
            text: "加载中……",
            spinner: "el-icon-loading",
            customClass: "loadClass",
            background: "rgba(255, 255, 255, 0.7)",
        });
        GetContentDetail(this, this.dataQuery.content_id, loading).then(
            (res: any) => {
                this.data = res.data;
                // 确保主症始终是数组格式
                if (this.data.report && this.data.report['主症']) {
                    if (!Array.isArray(this.data.report['主症'])) {
                        // 如果是字符串，转换为数组
                        this.data.report['主症'] = this.data.report['主症'] ? [this.data.report['主症']] : [];
                    }
                } else if (this.data.report) {
                    this.data.report['主症'] = [];
                }
                if (!this.data.name && this.data.template && this.data.template.name) {
                    this.data.name = this.data.template.name;
                }
            }
        );
    }
    /**
     * 保存
     */
    private async save() {
        try {
            //this.dataQuery.content_id不会有值，因为正常是新增进入，这里先占位
            let res: any;
            if (!this.dataQuery.content_id) {
                res = await this.saveTemplate(this.data);
            } else {
                res = await this.saveContent(this.data);
            }
            this.$message.success("保存成功！");
            this.$store.commit("updateIfCompose", false);
            this.$emit('saveSuccess', res.data);
        } catch (error) {
            console.log(error);
        }
    }
    private async saveTemplate(data: any) {
        const loading = this.$loading({
            lock: true,
            text: "加载中……",
            spinner: "el-icon-loading",
            customClass: "loadClass",
            background: "rgba(255, 255, 255, 0.7)",
        });

        try {
            const params: any = {
                collect_time: data.collect_time,
                patient: this.patient.id,
                data: data.data,
                template: data.template,
                related_type: '四诊客观化数据',
                report: data.report,
            };
            if (data.report) {
                params.report = data.report;
            }
            const res = await PostCepingContent(this, params, loading);
            return res.data;
        } catch (error) {
            loading.close();
            throw error;
        }
    }
    private async saveContent(data: any) {
        const loading = this.$loading({
            lock: true,
            text: "加载中……",
            spinner: "el-icon-loading",
            customClass: "loadClass",
            background: "rgba(255, 255, 255, 0.7)",
        });

        try {
            const res = await EditContent(this, data.id, data, loading);
            return res.data;
        } catch (error) {
            loading.close();
            throw error;
        }
    }

    /**
     * 保存并打印
     */
    private async goPrint() {
        let res;
        if (!this.dataQuery.content_id) {
            res = await this.saveTemplate(this.data);
        } else {
            res = await this.saveContent(this.data);
        }
        this.$store.commit("updateIfCompose", false);
        // 需要把闻诊的id也加入selectedIds
        this.selectedIds.push(res.id);
        this.$emit('goPrint', this.selectedIds);
    }

    private mounted() {
        // 拿浏览器参数
        console.log('路由参数');
        console.log(this.$route.query);
        const query = this.$route.query;
        if (query.name) {
            this.dataQuery.name = query.name;
        }
        if (query.template_id) {
            this.dataQuery.template_id = query.template_id;
        }
        if (query.patient_id) {
            this.dataQuery.patient_id = query.patient_id;
            this.getPatientData();
        }
        this.$store.commit("updateIfCompose", true);
        if (query.sizhenResult) {
            this.sizhenResult = JSON.parse(query.sizhenResult as any);
        }

        this.getData();
    }
}
